window._ = require('lodash');

window.moment = require('moment');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('select2');
} catch (e) {}

window.addEventListener("DOMContentLoaded", function() {
    window.jQuery('select.select2').select2({
        theme: "bootstrap",
    });
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.io = require('socket.io-client');

window.Echo = new Echo({
    broadcaster: process.env.MIX_ECHO_BROADCASTER,
    host: (process.env.MIX_ECHO_HOST || window.location.hostname) + (process.env.MIX_ECHO_PORT ? ':' + process.env.MIX_ECHO_PORT : ''),
    key: process.env.MIX_ECHO_KEY || null,
});

/**
 * Add a function to generate URIs
 */
window.route = function(templateUri, params) {
    const names = Object.keys(params);
    const vals = Object.values(params);
    return new Function(...names, `return \`${templateUri}\`;`)(...vals);
}
